module.exports = __webpack_public_path__ + "static/media/chat_yellow (1).7dad0bb5.png";